<template>
    <div
      class="faces-sidebar"
    >
      <PostFacesSidebarHeader
        @close="close"
      />

      <div
       class="faces-sidebar__scroll"
      >
        <q-linear-progress
          v-if="isLoading"
          indeterminate
          color="primary"
        />

        <div
          v-if="faces.length"
          class="row q-pa-sm q-col-gutter-sm"
        >
          <div
            v-for="face in faces"
            :key="face.id"
            class="col-4"
            @click="$emit('face-click', face)"
          >
            <PostFaceAvatar
              :face="face"
            />
          </div>
        </div>

        <div
          v-if="!isLoading && faces.length === 0"
          class="text-center text-grey-5 text-caption q-pa-lg"
        >
          No faces detected
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Face } from '@/analysis/types';
import { HasTaskMixin } from '@/mixins';
import postFaceRepository from '@/social/post-tag/post-face-repository';
import PostFacesSidebarHeader from './PostFacesSidebarHeader.vue';
import PostFaceAvatar from './PostFaceAvatar.vue';

interface Data {
  faces: Face[];
}

export default defineComponent({
  emits: ['close', 'face-click'],
  mixins: [HasTaskMixin],
  components: { PostFacesSidebarHeader, PostFaceAvatar },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    postId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      faces: [],
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    load() {
      this.task = postFaceRepository.findAllByPost(this.clientId, this.postId);
      this.task.then((faces: Face[]) => {
        this.faces = faces;
      });
    },
  },
  mounted() {
    this.load();
  },
});
</script>

<style scoped>
.faces-sidebar {
  width: 300px;
  min-height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
}

.faces-sidebar__scroll {
  overflow-y: auto;
  flex-shrink: 1;
  min-height: 0;
}
</style>
